import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { RichTextEditorStyles } from './RichTextEditor.style';
import { SEOContentStyles } from './SEOContent.style';

const SEOContent = ({ html, deviceType }) => {
  const isMobile = deviceType === 'mobile';
  const charLimit = isMobile ? 300 : 800;
  const ref = useRef();
  const [expanded, setExpanded] = useState(false);
  const [isExpandable] = useState(() => {
    const plainText = html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return plainText.length > charLimit;
  });

  const config = expanded
    ? { label: 'Mostrar menos', icon: 'csicon-arrow_up_small' }
    : {
        label: 'Mostrar más',
        icon: 'csicon-arrow_down_small',
      };

  let className = '';
  if (isExpandable) {
    className = expanded ? 'swatch-expanded' : 'swatch-collapsed';
  }

  const toggleSwatch = () => {
    if (expanded) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
    setExpanded(!expanded);
  };

  /* eslint-disable react/no-danger */
  return (
    <div ref={ref} className={`swatch ${className}`}>
      <div dangerouslySetInnerHTML={{ __html: html }} className="rich-text-editor description-content-text" />
      {isExpandable && (
        <button
          type="button"
          id={`${className}-id`}
          className={`showMore showMore-${expanded ? 'expand' : 'collapse'}Button`}
          onClick={toggleSwatch}
        >
          <span className="label">{config.label}</span>
          <span className="icon-right">
            <i className={config.icon} />
          </span>
        </button>
      )}
      <style dangerouslySetInnerHTML={{ __html: RichTextEditorStyles }} />
      <style jsx>{SEOContentStyles}</style>
    </div>
  );
  /* eslint-enable react/no-danger */
};

SEOContent.propTypes = {
  html: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
};

export { SEOContent };
